module.exports = __webpack_public_path__ + "static/media/4.641adc82.JPG";